export default __webpack_public_path__ + "static/placeholder-1-be7ddc39039d75f9e2fb734cee856cfd.jpg";